import { render, staticRenderFns } from "./EditPricingButton.vue?vue&type=template&id=cf7d70ac&"
import script from "./EditPricingButton.vue?vue&type=script&lang=js&"
export * from "./EditPricingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports